/**
 * AppModeProvider
 * 
 * Provides the current app mode to all components via React Context
 */

import React, { createContext, useContext } from 'react';
import type { AppMode } from '@/app/types/cad';

interface AppModeContextValue {
  mode: AppMode;
}

const AppModeContext = createContext<AppModeContextValue>({
  mode: 'iso-block',
});

export function useAppMode() {
  return useContext(AppModeContext);
}

interface AppModeProviderProps {
  mode: AppMode;
  children: React.ReactNode;
}

export function AppModeProvider({ mode, children }: AppModeProviderProps) {
  return (
    <AppModeContext.Provider value={{ mode }}>
      {children}
    </AppModeContext.Provider>
  );
}
